import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Avatar, Stack, Typography } from '@mui/material';
import { SmsDirection } from '@trnsact/trnsact-shared-types';
import { DealSmsActivity } from '../../api/types';
import { getPersonaInitials } from 'utils/formatters';
import { MessageBubble } from '../cards/MessageBubble';

interface Props {
  message: DealSmsActivity;
}

export const ConversationMessageBubble = ({ message }: Props) => {
  const isOutgoing = message.smsDirection === SmsDirection.Outgoing;

  const recepientInitials = getPersonaInitials(
    message.ownerPgCreditApplication?.firstName,
    message.ownerPgCreditApplication?.lastName
  );
  const senderInitials = getPersonaInitials(
    message.createdByUserProfile?.firstName,
    message.createdByUserProfile?.lastName
  );

  const classes = useStyles({ isOutgoing });

  return (
    <Stack direction="row" justifyContent={isOutgoing ? 'flex-end' : 'flex-start'} alignItems="flex-end" gap="0.5rem">
      {!isOutgoing && (
        <Avatar className={classes.avatar}>
          <Typography fontSize="0.75rem" fontWeight={500}>
            {recepientInitials}
          </Typography>
        </Avatar>
      )}

      <Stack maxWidth="70%" gap="0.25rem">
        <MessageBubble message={message} />
      </Stack>

      {isOutgoing && (
        <Avatar className={classes.avatar}>
          <Typography fontSize="0.75rem" fontWeight={500}>
            {senderInitials}
          </Typography>
        </Avatar>
      )}
    </Stack>
  );
};

const useStyles = makeStyles({
  avatar: (props: { isOutgoing: boolean }) => ({
    width: 32,
    height: 32,
    backgroundColor: props.isOutgoing ? '#E1BEE7' : '#90caf9',
    color: 'black',
    fontSize: '12px',
    flexShrink: 0,
  }),
});
